import FlexViewOne from "../../components/FlexView/FlexViewOne";
import GalleryCard from "../../components/cards/GalleryCard";
import PrimaryCard from "../../components/cards/PrimaryCard";
import BackgroundSection from "../../components/sections/BackgroundSection/BackgroundSection";
import DarkSection from "../../components/sections/ColoredSection/DarkSection";
import GallerySection from "../../components/sections/GallerySection/GallerySection";
import GallerySectionCol from "../../components/sections/GallerySection/GallerySectionCol";
import GallerySectionRow from "../../components/sections/GallerySection/GallerySectionRow";
import ourCommitmentsPageData from "../../data/arabic/our-commitments-page-data-ar";
import Footer from "../../layouts/Footer";
import MainHeader from "../../layouts/MainHeader";

const CommitmentsPageAr = () => {
    return (
        <main id="main" className="page">
            <div className="sticky-view">
                <div className="sticky-container">
                    <MainHeader 
                        title={ourCommitmentsPageData.title}
                        image={{
                            src : require(`../../assets/images/backgrounds/${ourCommitmentsPageData.headerImage.name}`),
                            alt : ourCommitmentsPageData.headerImage.alt,
                        }}
                    />
                </div>
                <div className="sticky-container-two" id="mainContent">
                    <div className="wrapper-small">
                        <div className="translate-bottom">
                            <GallerySection>
                                <GallerySectionRow>
                                {
                                ourCommitmentsPageData.gridOne.rowOne.map((item, index) => (
                                    <GallerySectionCol>
                                        <GalleryCard 
                                            title={item.title}
                                            subtitle={item.subtitle}
                                            image={{
                                                src : require(`../../assets/images/cards/${item.image.name}`),
                                                alt : item.image.alt,
                                            }}
                                            button={item.button}
                                        />
                                    </GallerySectionCol>
                                ))
                                }
                                </GallerySectionRow>
                                <GallerySectionRow>
                                {
                                ourCommitmentsPageData.gridOne.rowTwo.map((item, index) => (
                                    <GallerySectionCol>
                                        <GalleryCard
                                            key={index}
                                            title={item.title}
                                            subtitle={item.subtitle}
                                            image={item.image ? {
                                                src : require(`../../assets/images/cards/${item.image?.name}`),
                                                alt : item.image.alt,
                                            } : undefined}
                                            button={item.button}
                                        />
                                    </GallerySectionCol>
                                ))
                                }
                                </GallerySectionRow>
                            </GallerySection>

                        </div>
                        <div className="margin-box"></div>
                        <div className="margin-box"></div>
                        <div className="margin-box"></div>
                    </div>
                    <BackgroundSection 
                        title={ourCommitmentsPageData.sectionTwo.title}
                        subtitle={ourCommitmentsPageData.sectionTwo.subtitle}
                        image={{
                            src : require('../../assets/images/sections/saudi-green.jpg'),
                            alt : "Saudi green initiative",
                        }}
                        button={ourCommitmentsPageData.sectionTwo.button}
                    />
                    <Footer withBlogs={false} />
                </div>
            </div>
        </main>
)
}

export default CommitmentsPageAr;